document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const menuPanel = document.querySelector("[data-menu-panel]");
  const dropdownContainers = Array.from(document.querySelectorAll(".site-header__dropdown"));
  const dropdownDetails = Array.from(document.querySelectorAll(".site-header__dropdown details"));
  const desktopDropdownMedia = window.matchMedia("(min-width: 990px)");

  if (menuToggle && menuPanel) {
    menuToggle.addEventListener("click", () => {
      const isOpen = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!isOpen));
      menuPanel.toggleAttribute("data-open");
    });
  }

  const closeHeaderDropdowns = (exceptDetails) => {
    dropdownDetails.forEach((details) => {
      if (!(details instanceof HTMLDetailsElement) || details === exceptDetails) {
        return;
      }

      details.open = false;
    });
  };

  dropdownDetails.forEach((details) => {
    if (!(details instanceof HTMLDetailsElement)) {
      return;
    }

    details.addEventListener("toggle", () => {
      if (!details.open) {
        return;
      }

      closeHeaderDropdowns(details);
    });

    details.addEventListener("pointerenter", () => {
      if (!desktopDropdownMedia.matches) {
        return;
      }

      closeHeaderDropdowns(details);
      details.open = true;
    });
  });

  dropdownContainers.forEach((dropdown) => {
    if (!(dropdown instanceof HTMLElement)) {
      return;
    }

    const details = dropdown.querySelector("details");

    if (!(details instanceof HTMLDetailsElement)) {
      return;
    }

    dropdown.addEventListener("pointerenter", () => {
      if (!desktopDropdownMedia.matches) {
        return;
      }

      closeHeaderDropdowns(details);
      details.open = true;
    });

    dropdown.addEventListener("pointerleave", () => {
      if (!desktopDropdownMedia.matches) {
        return;
      }

      details.open = false;
    });
  });

  document.addEventListener("pointerdown", (event) => {
    if (!desktopDropdownMedia.matches) {
      return;
    }

    const target = event.target;

    if (target instanceof Element && target.closest(".site-header__dropdown")) {
      return;
    }

    closeHeaderDropdowns();
  });

  document.querySelectorAll("[data-summary-link]").forEach((summary) => {
    if (!(summary instanceof HTMLElement)) {
      return;
    }

    summary.addEventListener("click", (event) => {
      const href = summary.getAttribute("data-summary-link");
      const target = event.target;
      const isKeyboardClick = event.detail === 0;

      if (!href || isKeyboardClick || !(target instanceof Element)) {
        return;
      }

      if (target.closest(".site-header__caret")) {
        return;
      }

      event.preventDefault();
      window.location.href = href;
    });
  });

  const searchDrawer = document.querySelector("[data-search-drawer]");

  if (searchDrawer instanceof HTMLElement) {
    const searchPanel = searchDrawer.querySelector(".search-drawer__panel");
    const searchInput = searchDrawer.querySelector("[data-search-focus]");
    const searchForm = searchDrawer.querySelector("form");
    const searchToggles = document.querySelectorAll("[data-search-toggle]");
    let activeElementBeforeSearch = null;

    const syncSearchToggleState = (isOpen) => {
      searchToggles.forEach((toggle) => {
        toggle.setAttribute("aria-expanded", String(isOpen));
      });
    };

    const openSearch = () => {
      activeElementBeforeSearch = document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

      searchDrawer.setAttribute("data-open", "");
      searchDrawer.setAttribute("aria-hidden", "false");
      document.body.setAttribute("data-search-open", "");
      syncSearchToggleState(true);

      window.requestAnimationFrame(() => {
        if (searchPanel instanceof HTMLElement) {
          searchPanel.focus();
        }

        if (searchInput instanceof HTMLInputElement) {
          searchInput.focus();
          searchInput.select();
        }
      });
    };

    const closeSearch = () => {
      searchDrawer.removeAttribute("data-open");
      searchDrawer.setAttribute("aria-hidden", "true");
      document.body.removeAttribute("data-search-open");
      syncSearchToggleState(false);

      if (activeElementBeforeSearch instanceof HTMLElement && activeElementBeforeSearch.isConnected) {
        activeElementBeforeSearch.focus();
      }
    };

    searchToggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        if (searchDrawer.hasAttribute("data-open")) {
          closeSearch();
          return;
        }

        openSearch();
      });
    });

    searchDrawer.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const closeTrigger = target.closest("[data-search-close]");
      if (!closeTrigger) {
        return;
      }

      if (!(closeTrigger instanceof HTMLAnchorElement)) {
        event.preventDefault();
      }

      closeSearch();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && searchDrawer.hasAttribute("data-open")) {
        closeSearch();
      }
    });

    if (searchForm instanceof HTMLFormElement) {
      searchForm.addEventListener("submit", (event) => {
        const query = searchInput instanceof HTMLInputElement ? searchInput.value.trim() : "";
        if (query) {
          return;
        }

        event.preventDefault();

        if (searchInput instanceof HTMLInputElement) {
          searchInput.focus();
        }
      });
    }
  }

  document.querySelectorAll("[data-password-field]").forEach((field) => {
    const input = field.querySelector("[data-password-input]");
    const toggle = field.querySelector("[data-password-toggle]");
    const label = toggle?.querySelector("[data-password-label]");

    if (!(input instanceof HTMLInputElement) || !(toggle instanceof HTMLButtonElement)) {
      return;
    }

    toggle.addEventListener("click", () => {
      const isVisible = input.type === "text";
      input.type = isVisible ? "password" : "text";
      toggle.setAttribute("aria-pressed", String(!isVisible));
      toggle.setAttribute("aria-label", isVisible ? "Show password" : "Hide password");

      if (label instanceof HTMLElement) {
        label.textContent = isVisible ? "Show" : "Hide";
      }
    });
  });

  document.querySelectorAll("[data-cart-page-quantity]").forEach((wrapper) => {
    const input = wrapper.querySelector("[data-cart-page-input]");

    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    wrapper.querySelectorAll("[data-cart-page-change]").forEach((button) => {
      button.addEventListener("click", () => {
        const step = Number(button.getAttribute("data-cart-page-change") || 0);
        const currentValue = Number(input.value || 0);
        const nextValue = Math.max(0, currentValue + step);
        input.value = String(nextValue);
      });
    });
  });

  const cartDrawer = document.querySelector("[data-cart-drawer]");

  if (cartDrawer instanceof HTMLElement) {
    const cartPanel = cartDrawer.querySelector(".cart-drawer__panel");
    const cartItems = cartDrawer.querySelector("[data-cart-items]");
    const cartEmpty = cartDrawer.querySelector("[data-cart-empty]");
    const cartFooter = cartDrawer.querySelector("[data-cart-footer]");
    const cartSubtotal = cartDrawer.querySelector("[data-cart-subtotal]");
    const cartSavings = cartDrawer.querySelector("[data-cart-savings]");
    const cartSavingsValue = cartDrawer.querySelector("[data-cart-savings-value]");
    const cartNote = cartDrawer.querySelector("[data-cart-note]");
    const cartShipping = cartDrawer.querySelector("[data-cart-shipping]");
    const cartShippingMessage = cartDrawer.querySelector("[data-cart-shipping-message]");
    const cartShippingProgress = cartDrawer.querySelector("[data-cart-shipping-progress]");
    const cartToggles = document.querySelectorAll("[data-cart-toggle]");
    const cartCountBadges = document.querySelectorAll("[data-cart-count]");
    const cartCountLabels = document.querySelectorAll("[data-cart-count-label]");
    const freeShippingThreshold = Number(cartDrawer.dataset.freeShippingThreshold || 0);
    const shopifyRoot = window.Shopify?.routes?.root || "/";
    let activeElementBeforeCart = null;
    let currentCurrency = cartDrawer.dataset.currency || "CAD";
    let cartBusy = false;

    const buildCartUrl = (path) => {
      const normalizedRoot = shopifyRoot.endsWith("/") ? shopifyRoot : `${shopifyRoot}/`;
      const normalizedPath = String(path || "").replace(/^\/+/, "");
      return `${normalizedRoot}${normalizedPath}`;
    };

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;

      try {
        return new Intl.NumberFormat("en-CA", {
          style: "currency",
          currency: currentCurrency,
          minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    };

    const getControlLabel = (control) => {
      if (!control) {
        return "";
      }

      return control instanceof HTMLInputElement ? control.value : control.textContent || "";
    };

    const setControlLabel = (control, label) => {
      if (!control) {
        return;
      }

      if (control instanceof HTMLInputElement) {
        control.value = label;
        return;
      }

      control.textContent = label;
    };

    const setCartBusy = (busy) => {
      cartBusy = busy;
      cartDrawer.toggleAttribute("data-busy", busy);
      if (cartPanel instanceof HTMLElement) {
        cartPanel.setAttribute("aria-busy", String(busy));
      }
    };

    const syncCartToggleState = (isOpen) => {
      cartToggles.forEach((toggle) => {
        toggle.setAttribute("aria-expanded", String(isOpen));
      });
    };

    const openCart = () => {
      activeElementBeforeCart = document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

      cartDrawer.setAttribute("data-open", "");
      cartDrawer.setAttribute("aria-hidden", "false");
      document.body.setAttribute("data-cart-open", "");
      syncCartToggleState(true);

      if (cartPanel instanceof HTMLElement) {
        window.requestAnimationFrame(() => {
          cartPanel.focus();
        });
      }
    };

    const closeCart = () => {
      cartDrawer.removeAttribute("data-open");
      cartDrawer.setAttribute("aria-hidden", "true");
      document.body.removeAttribute("data-cart-open");
      syncCartToggleState(false);

      if (activeElementBeforeCart instanceof HTMLElement && activeElementBeforeCart.isConnected) {
        activeElementBeforeCart.focus();
      }
    };

    const isLedFlexOfferItem = (item) => {
      const productHandle = item.handle || item.product_handle || "";
      const discounts = Array.isArray(item.discounts) ? item.discounts : [];
      const hasOfferDiscount = discounts.some((discount) => {
        const title = String(discount?.title || "").toLowerCase();
        return title.includes("flex199landing") || (
          title.includes("led flex landing offer") && title.includes("$199")
        );
      });

      return productHandle === "led-flex-mask" && hasOfferDiscount;
    };

    const renderCartItem = (item) => {
      const productTitle = item.product_title || item.title || "Product";
      const imageUrl = item.image || item.featured_image?.url || "";
      const itemUrl = item.url || "/cart";
      const variantTitle = item.variant_title && item.variant_title !== "Default Title"
        ? item.variant_title
        : "";
      const productHandle = item.handle || item.product_handle || "";
      const quantity = Number(item.quantity || 0);
      const variantId = Number(item.variant_id || item.id || 0);
      const originalPrice = Number(item.original_price || item.price || 0);
      const finalPrice = Number(item.final_price || item.price || 0);
      const savings = Math.max(0, originalPrice - finalPrice);
      const isLedFlexOffer = isLedFlexOfferItem(item);
      const price = formatMoney(finalPrice);
      const key = item.key || "";
      const imageMarkup = imageUrl
        ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(productTitle)}" loading="lazy">`
        : `<div class="media-placeholder">${escapeHtml(productTitle)}</div>`;

      return `
        <li class="cart-drawer__item${isLedFlexOffer ? " cart-drawer__item--led-offer" : ""}" data-cart-item data-cart-key="${escapeHtml(key)}" data-cart-quantity="${quantity}" data-cart-variant-id="${escapeHtml(variantId)}" data-cart-product-handle="${escapeHtml(productHandle)}">
          <a class="cart-drawer__item-media" href="${escapeHtml(itemUrl)}">
            ${imageMarkup}
          </a>
          <div class="cart-drawer__item-main">
            <a class="cart-drawer__item-title" href="${escapeHtml(itemUrl)}">${escapeHtml(productTitle)}</a>
            ${variantTitle ? `<p class="cart-drawer__item-variant">${escapeHtml(variantTitle)}</p>` : ""}
            ${productHandle === "led-flex-mask" ? '<p class="cart-drawer__item-reminder">8 settings &bull; Flexible fit &bull; 10–20 minutes</p>' : ""}
            <p class="cart-drawer__item-price">
              <strong>${escapeHtml(price)}</strong>
              ${savings > 0 ? `<s>${escapeHtml(formatMoney(originalPrice))}</s><span>Save ${escapeHtml(formatMoney(savings))}</span>` : ""}
            </p>
            ${isLedFlexOffer ? '<p class="cart-drawer__item-offer"><span aria-hidden="true">✓</span> Free shipping included</p>' : ""}
            <div class="cart-drawer__item-meta">
              <div class="cart-drawer__qty">
                <button
                  class="cart-drawer__qty-button"
                  type="button"
                  aria-label="Decrease quantity for ${escapeHtml(productTitle)}"
                  data-cart-key="${escapeHtml(key)}"
                  data-cart-quantity-change="-1"
                >
                  &minus;
                </button>
                <span class="cart-drawer__qty-value">${quantity}</span>
                <button
                  class="cart-drawer__qty-button"
                  type="button"
                  aria-label="Increase quantity for ${escapeHtml(productTitle)}"
                  data-cart-key="${escapeHtml(key)}"
                  data-cart-quantity-change="1"
                >
                  +
                </button>
              </div>
            </div>
          </div>
          <button
            class="cart-drawer__remove"
            type="button"
            aria-label="Remove ${escapeHtml(productTitle)} from cart"
            data-cart-key="${escapeHtml(key)}"
            data-cart-remove
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M6 6 18 18M18 6 6 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.8"></path>
            </svg>
          </button>
        </li>
      `;
    };

    const renderCart = (cart) => {
      const itemCount = Number(cart?.item_count || 0);
      const totalPrice = Number(cart?.total_price || 0);
      const originalTotalPrice = Number(cart?.original_total_price || totalPrice);
      const totalSavings = Math.max(0, originalTotalPrice - totalPrice);
      const cartItemsData = Array.isArray(cart?.items) ? cart.items : [];
      const hasLedFlexOffer = cartItemsData.some(isLedFlexOfferItem);
      const hasSubscription = cartItemsData.some((item) => Boolean(item?.selling_plan_allocation));
      const ledShippingGuaranteed = hasLedFlexOffer && !hasSubscription;

      if (cart?.currency) {
        currentCurrency = cart.currency;
      }

      cartCountBadges.forEach((badge) => {
        badge.textContent = String(itemCount);
        badge.hidden = itemCount === 0;
      });

      cartCountLabels.forEach((label) => {
        label.textContent = itemCount > 0 ? `(${itemCount})` : "";
      });

      cartToggles.forEach((toggle) => {
        toggle.setAttribute(
          "aria-label",
          itemCount > 0 ? `Cart, ${itemCount} item${itemCount === 1 ? "" : "s"}` : "Cart"
        );
      });

      if (cartSubtotal) {
        cartSubtotal.textContent = formatMoney(totalPrice);
      }

      if (cartSavings && cartSavingsValue) {
        cartSavings.hidden = totalSavings <= 0;
        cartSavingsValue.textContent = totalSavings > 0 ? `−${formatMoney(totalSavings)}` : "";
      }

      cartDrawer.toggleAttribute("data-led-offer", hasLedFlexOffer);

      if (cartNote) {
        cartNote.innerHTML = ledShippingGuaranteed
          ? "Free shipping included &bull; Taxes at checkout"
          : "Shipping and taxes shown at checkout";
      }

      if (itemCount === 0) {
        if (cartItems) {
          cartItems.innerHTML = "";
          cartItems.hidden = true;
        }

        if (cartEmpty) {
          cartEmpty.hidden = false;
        }

        if (cartFooter) {
          cartFooter.hidden = true;
        }

        if (cartShipping) {
          cartShipping.hidden = true;
        }

        cartDrawer.removeAttribute("data-led-offer");

        return;
      }

      if (cartItems) {
        cartItems.innerHTML = cartItemsData.map(renderCartItem).join("");
        cartItems.hidden = false;
      }

      if (cartEmpty) {
        cartEmpty.hidden = true;
      }

      if (cartFooter) {
        cartFooter.hidden = false;
      }

      if (cartShipping && cartShippingMessage && cartShippingProgress) {
        if (hasLedFlexOffer) {
          cartShipping.hidden = false;
          cartShippingMessage.innerHTML = ledShippingGuaranteed
            ? '<span aria-hidden="true">✓</span> Free shipping included with your LED FLEX offer'
            : "LED FLEX shipping offer applied. Final mixed-order shipping at checkout.";
          cartShippingProgress.style.width = "100%";
        } else if (freeShippingThreshold > 0) {
          const freeShippingRemaining = Math.max(0, freeShippingThreshold - totalPrice);
          const freeShippingProgress = Math.min(100, (totalPrice / freeShippingThreshold) * 100);

          cartShipping.hidden = false;
          cartShippingMessage.innerHTML = freeShippingRemaining > 0
            ? `You're <strong>${formatMoney(freeShippingRemaining)}</strong> away from free shipping`
            : "You've unlocked free shipping!";
          cartShippingProgress.style.width = `${freeShippingProgress}%`;
        } else {
          cartShipping.hidden = true;
        }
      }
    };

    const fetchCart = async () => {
      const response = await fetch(buildCartUrl("cart.js"), {
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Cart fetch failed with status ${response.status}`);
      }

      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const changeCartItem = async (key, quantity) => {
      setCartBusy(true);

      try {
        const response = await fetch(buildCartUrl("cart/change.js"), {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: key,
            quantity
          })
        });

        if (!response.ok) {
          throw new Error(`Cart update failed with status ${response.status}`);
        }

        const cart = await response.json();
        renderCart(cart);
        return cart;
      } finally {
        setCartBusy(false);
      }
    };

    cartToggles.forEach((toggle) => {
      toggle.addEventListener("click", async (event) => {
        event.preventDefault();

        if (cartDrawer.hasAttribute("data-open")) {
          closeCart();
          return;
        }

        try {
          await fetchCart();
        } catch (error) {
          console.error(error);
        }

        openCart();
      });
    });

    cartDrawer.addEventListener("click", async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const closeTrigger = target.closest("[data-cart-close]");
      if (closeTrigger) {
        if (!(closeTrigger instanceof HTMLAnchorElement)) {
          event.preventDefault();
        }

        closeCart();
        return;
      }

      const removeTrigger = target.closest("[data-cart-remove]");
      if (removeTrigger) {
        event.preventDefault();

        if (cartBusy) {
          return;
        }

        const key = removeTrigger.getAttribute("data-cart-key");
        if (!key) {
          return;
        }

        try {
          await changeCartItem(key, 0);
        } catch (error) {
          console.error(error);
          window.alert("We couldn't update your cart just now. Please try again.");
        }

        return;
      }

      const quantityTrigger = target.closest("[data-cart-quantity-change]");
      if (!quantityTrigger) {
        return;
      }

      event.preventDefault();

      if (cartBusy) {
        return;
      }

      const item = quantityTrigger.closest("[data-cart-item]");
      const key = quantityTrigger.getAttribute("data-cart-key") || item?.getAttribute("data-cart-key");
      const currentQuantity = Number(item?.getAttribute("data-cart-quantity") || 0);
      const nextQuantity = Math.max(
        0,
        currentQuantity + Number(quantityTrigger.getAttribute("data-cart-quantity-change") || 0)
      );

      if (!key || nextQuantity === currentQuantity) {
        return;
      }

      try {
        await changeCartItem(key, nextQuantity);
      } catch (error) {
        console.error(error);
        window.alert("We couldn't update your cart just now. Please try again.");
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && cartDrawer.hasAttribute("data-open")) {
        closeCart();
      }
    });

    document.addEventListener("submit", async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.action.includes("/cart/add")) {
        return;
      }

      const submitButton = event.submitter || form.querySelector("[type='submit']");
      const isBuyNow = submitButton instanceof HTMLElement && submitButton.hasAttribute("data-buy-now");

      if (isBuyNow) {
        // The Buy now submitter supplies return_to=/checkout. Let Shopify
        // process the native product form so only one commerce handoff occurs.
        return;
      }

      event.preventDefault();

      const originalLabel = getControlLabel(submitButton);

      if (submitButton instanceof HTMLButtonElement || submitButton instanceof HTMLInputElement) {
        submitButton.disabled = true;
        setControlLabel(submitButton, isBuyNow ? "Redirecting..." : "Adding...");
      }

      try {
        const response = await fetch(buildCartUrl("cart/add.js"), {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: new FormData(form)
        });

        const payload = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error(payload?.description || "We couldn't add that item to your cart.");
        }

        if (isBuyNow) {
          window.location.href = buildCartUrl("checkout");
          return;
        }

        await fetchCart();
        openCart();
      } catch (error) {
        console.error(error);
        window.alert(error instanceof Error ? error.message : "We couldn't add that item to your cart.");
      } finally {
        if (submitButton instanceof HTMLButtonElement || submitButton instanceof HTMLInputElement) {
          submitButton.disabled = false;
          setControlLabel(submitButton, originalLabel);
        }
      }
    });
  }

  document.querySelectorAll("[data-accordion]").forEach((accordion) => {
    accordion.querySelectorAll("[data-accordion-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const item = trigger.closest("[data-accordion-item]");
        const panel = item && item.querySelector("[data-accordion-panel]");
        const expanded = trigger.getAttribute("aria-expanded") === "true";

        if (!item || !panel) return;

        trigger.setAttribute("aria-expanded", String(!expanded));
        panel.hidden = expanded;
        item.classList.toggle("is-open", !expanded);
      });
    });
  });

  document.querySelectorAll("[data-learn-guides-root]").forEach((root) => {
    const shell = root.querySelector("[data-learn-guide-shell]");
    const viewer = root.querySelector("[data-learn-guide-viewer]");

    if (!shell || !viewer) {
      return;
    }

    const clearGuide = () => {
      shell.hidden = true;
      viewer.innerHTML = "";
    };

    const syncHash = (slug) => {
      if (!window.history || !window.history.replaceState) {
        window.location.hash = slug ? `guide-${slug}` : "";
        return;
      }

      const nextUrl = slug
        ? `${window.location.pathname}${window.location.search}#guide-${slug}`
        : `${window.location.pathname}${window.location.search}`;

      window.history.replaceState(null, "", nextUrl);
    };

    const renderGuide = (slug) => {
      const template = root.querySelector(`[data-learn-guide-template="${slug}"]`);
      if (!(template instanceof HTMLTemplateElement)) {
        return;
      }

      viewer.innerHTML = "";
      viewer.appendChild(template.content.cloneNode(true));
      shell.hidden = false;
      syncHash(slug);
      shell.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const openGuideFromHash = () => {
      const match = window.location.hash.match(/^#guide-(.+)$/);
      if (!match) {
        clearGuide();
        return;
      }

      renderGuide(match[1]);
    };

    root.querySelectorAll("[data-learn-guide-trigger]").forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        const slug = trigger.dataset.learnGuideTrigger;
        if (!slug) {
          return;
        }

        renderGuide(slug);
      });
    });

    root.addEventListener("click", (event) => {
      const closeButton = event.target.closest("[data-learn-guide-close]");
      if (!closeButton) {
        return;
      }

      event.preventDefault();
      clearGuide();
      syncHash("");
    });

    openGuideFromHash();
    window.addEventListener("hashchange", openGuideFromHash);
  });

  document.querySelectorAll("[data-purchase-options]").forEach((wrapper) => {
    const cards = wrapper.querySelectorAll("[data-purchase-card]");
    const button = wrapper.querySelector("[data-purchase-button]");
    const commitment = wrapper.querySelector("[data-purchase-commitment]");
    const summary = wrapper.querySelector("[data-purchase-summary]");
    const hiddenSellingPlan = wrapper.querySelector("[data-selling-plan-input]");

    const syncCardState = () => {
      cards.forEach((card) => {
        const input = card.querySelector("input[type='radio']");
        const active = input && input.checked;
        card.classList.toggle("is-active", Boolean(active));

        if (!active) return;

        if (button && card.dataset.buttonLabel) {
          button.textContent = card.dataset.buttonLabel;
        }

        if (commitment && card.dataset.commitmentNote) {
          commitment.textContent = card.dataset.commitmentNote;
        }

        if (summary && card.dataset.summary) {
          summary.textContent = card.dataset.summary;
        }

        if (hiddenSellingPlan) {
          hiddenSellingPlan.value = card.dataset.sellingPlanId || "";
        }
      });
    };

    cards.forEach((card) => {
      const input = card.querySelector("input[type='radio']");
      if (!input) return;
      input.addEventListener("change", syncCardState);
    });

    syncCardState();
  });

  document.querySelectorAll("[data-founder-video]").forEach((root) => {
    const video = root.querySelector("[data-founder-video-media]");
    const trigger = root.querySelector("[data-founder-video-trigger]");

    if (!(video instanceof HTMLVideoElement) || !(trigger instanceof HTMLButtonElement)) {
      return;
    }

    const showOverlay = () => {
      root.classList.remove("is-playing");
    };

    const hideOverlay = () => {
      root.classList.add("is-playing");
    };

    trigger.addEventListener("click", async () => {
      hideOverlay();

      try {
        await video.play();
      } catch (error) {
        if (typeof video.focus === "function") {
          video.focus();
        }
      }
    });

    video.addEventListener("play", hideOverlay);
    video.addEventListener("ended", showOverlay);

    if (!video.paused && !video.ended) {
      hideOverlay();
    } else {
      showOverlay();
    }
  });

  document.querySelectorAll("[data-routeine-gallery]").forEach((gallery) => {
    const featuredImage = gallery.querySelector("[data-routeine-featured-image]");
    const thumbs = gallery.querySelectorAll("[data-routeine-thumb]");

    if (!featuredImage || !thumbs.length) {
      return;
    }

    const syncThumbState = (activeThumb) => {
      thumbs.forEach((thumb) => {
        const isActive = thumb === activeThumb;
        thumb.classList.toggle("is-active", isActive);
        thumb.setAttribute("aria-pressed", String(isActive));
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const nextSrc = thumb.dataset.routeineSrc;
        const nextAlt = thumb.dataset.routeineAlt;

        if (nextSrc) {
          featuredImage.setAttribute("src", nextSrc);
        }

        if (nextAlt) {
          featuredImage.setAttribute("alt", nextAlt);
        }

        syncThumbState(thumb);
      });
    });
  });

  document.querySelectorAll("[data-routeine-card-gallery]").forEach((gallery) => {
    const slides = gallery.querySelectorAll("[data-routeine-card-slide]");
    const dots = gallery.querySelectorAll("[data-routeine-card-dot]");
    const media = gallery.querySelector(".routeine-box-card__media");
    let activeIndex = 0;
    let swipeStart = null;

    if (!slides.length || slides.length !== dots.length) {
      return;
    }

    const showSlide = (nextCandidateIndex) => {
      const nextIndex = (nextCandidateIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        slide.classList.toggle("is-active", index === nextIndex);
      });

      dots.forEach((dot, index) => {
        const isActive = index === nextIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-pressed", String(isActive));
      });

      activeIndex = nextIndex;
    };

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => showSlide(index));
    });

    if (media) {
      const beginSwipe = (x, y) => {
        swipeStart = { x, y };
      };

      const cancelSwipe = () => {
        swipeStart = null;
      };

      const endSwipe = (x, y) => {
        if (!swipeStart) {
          return;
        }

        const dx = x - swipeStart.x;
        const dy = y - swipeStart.y;

        swipeStart = null;

        if (Math.abs(dx) <= 40 || Math.abs(dx) <= Math.abs(dy)) {
          return;
        }

        showSlide(dx < 0 ? activeIndex + 1 : activeIndex - 1);
      };

      media.style.touchAction = "pan-y";
      media.addEventListener("dragstart", (event) => event.preventDefault());

      media.addEventListener(
        "touchstart",
        (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          beginSwipe(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      media.addEventListener("touchend", (event) => {
        const touch = event.changedTouches[0];
        if (!touch) {
          cancelSwipe();
          return;
        }

        endSwipe(touch.clientX, touch.clientY);
      });

      media.addEventListener("touchcancel", cancelSwipe);

      media.addEventListener("mousedown", (event) => {
        if (event.button !== 0) {
          return;
        }

        beginSwipe(event.clientX, event.clientY);
      });

      window.addEventListener("mouseup", (event) => {
        if (!swipeStart) {
          return;
        }

        endSwipe(event.clientX, event.clientY);
      });

      media.addEventListener("mouseleave", (event) => {
        if ((event.buttons & 1) !== 1 || !swipeStart) {
          return;
        }

        endSwipe(event.clientX, event.clientY);
      });
    }

    const initialActiveIndex = Array.from(slides).findIndex((slide) => slide.classList.contains("is-active"));
    showSlide(initialActiveIndex >= 0 ? initialActiveIndex : 0);
  });

  document.querySelectorAll("[data-routeine-strip-slider]").forEach((slider) => {
    const track = slider.querySelector("[data-routeine-strip-track]");
    const prev = slider.querySelector("[data-routeine-strip-prev]");
    const next = slider.querySelector("[data-routeine-strip-next]");

    if (!track || !prev || !next) {
      return;
    }

    const getStep = () => {
      const firstCard = track.firstElementChild;
      const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || "0");

      if (!(firstCard instanceof HTMLElement)) {
        return track.clientWidth * 0.85;
      }

      return firstCard.getBoundingClientRect().width + gap;
    };

    const loadImagesInRange = (start, end) => {
      Array.from(track.children).forEach((card) => {
        if (!(card instanceof HTMLElement)) {
          return;
        }

        const cardStart = card.offsetLeft;
        const cardEnd = cardStart + card.offsetWidth;

        if (cardEnd < start || cardStart > end) {
          return;
        }

        card.querySelectorAll("img[loading='lazy']").forEach((image) => {
          const source = image.currentSrc || image.src;

          image.loading = "eager";

          if (source && !image.complete) {
            const preload = new Image();
            preload.src = source;
            image.src = source;
          }
        });
      });
    };

    const loadNearbyImages = () => {
      loadImagesInRange(
        Math.max(0, track.scrollLeft - track.clientWidth),
        track.scrollLeft + track.clientWidth * 2.5
      );
    };

    const syncControls = () => {
      const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth - 4);
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= maxScrollLeft;

      prev.disabled = atStart;
      next.disabled = atEnd;
      slider.classList.toggle("is-static", maxScrollLeft <= 4);
    };

    prev.addEventListener("click", () => {
      const step = getStep();

      loadImagesInRange(Math.max(0, track.scrollLeft - step * 2), track.scrollLeft + track.clientWidth);
      track.scrollBy({ left: -step, behavior: "smooth" });
    });

    next.addEventListener("click", () => {
      const step = getStep();

      loadImagesInRange(track.scrollLeft, track.scrollLeft + track.clientWidth + step * 2);
      track.scrollBy({ left: step, behavior: "smooth" });
    });

    let syncFrame = 0;
    const queueSliderSync = () => {
      if (syncFrame) {
        return;
      }

      syncFrame = window.requestAnimationFrame(() => {
        syncFrame = 0;
        loadNearbyImages();
        syncControls();
      });
    };

    track.addEventListener("scroll", queueSliderSync, { passive: true });
    window.addEventListener("resize", queueSliderSync);
    loadNearbyImages();
    syncControls();
  });

  document.querySelectorAll("[data-events-page]").forEach((root) => {
    const payloadNode = root.querySelector("[data-events-page-data]");
    const filtersNode = root.querySelector("[data-events-filters]");
    const calendarView = root.querySelector("[data-events-calendar-view]");
    const listView = root.querySelector("[data-events-list-view]");
    const emptyState = root.querySelector("[data-events-empty]");
    const monthLabel = root.querySelector("[data-events-month-label]");
    const weekdayRow = root.querySelector("[data-events-weekdays]");
    const gridNode = root.querySelector("[data-events-grid]");
    const tabShell = root.querySelector("[data-events-tabs]");
    const modal = root.querySelector("[data-events-modal]");
    const modalContent = root.querySelector("[data-events-modal-content]");
    const viewButtons = Array.from(root.querySelectorAll("[data-events-view]"));
    const tabButtons = Array.from(root.querySelectorAll("[data-events-list-tab]"));
    const prevButton = root.querySelector("[data-events-prev]");
    const nextButton = root.querySelector("[data-events-next]");
    const todayButton = root.querySelector("[data-events-today]");

    if (
      !(payloadNode instanceof HTMLScriptElement)
      || !(filtersNode instanceof HTMLElement)
      || !(calendarView instanceof HTMLElement)
      || !(listView instanceof HTMLElement)
      || !(emptyState instanceof HTMLElement)
      || !(monthLabel instanceof HTMLElement)
      || !(weekdayRow instanceof HTMLElement)
      || !(gridNode instanceof HTMLElement)
      || !(modal instanceof HTMLElement)
      || !(modalContent instanceof HTMLElement)
    ) {
      return;
    }

    let events = [];

    try {
      events = JSON.parse(payloadNode.textContent || "[]");
    } catch (error) {
      return;
    }

    if (!Array.isArray(events) || !events.length) {
      return;
    }

    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const state = {
      view: "calendar",
      tab: "upcoming",
      typeFilter: "All",
      selectedId: "",
      cursor: new Date(today.getFullYear(), today.getMonth(), 1)
    };

    const startOfToday = () => {
      const value = new Date();
      value.setHours(0, 0, 0, 0);
      return value;
    };

    const isUpcoming = (event) => new Date(`${event.date}T00:00:00`) >= startOfToday();

    const formatDate = (dateString) => {
      const value = new Date(`${dateString}T00:00:00`);

      return {
        monthShort: value.toLocaleString("en-US", { month: "short" }).toUpperCase(),
        day: value.getDate(),
        full: value.toLocaleDateString("en-US", {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        })
      };
    };

    const ymd = (value) => {
      const year = value.getFullYear();
      const month = `${value.getMonth() + 1}`.padStart(2, "0");
      const day = `${value.getDate()}`.padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const buildMonthCells = (cursor) => {
      const start = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
      start.setDate(1 - start.getDay());

      return Array.from({ length: 42 }, (_, index) => {
        const value = new Date(start);
        value.setDate(start.getDate() + index);
        return value;
      });
    };

    const getUpcomingEvents = () =>
      events.filter(isUpcoming).sort((left, right) => left.date.localeCompare(right.date));

    const getPastEvents = () =>
      events.filter((event) => !isUpcoming(event)).sort((left, right) => right.date.localeCompare(left.date));

    const getBaseEvents = () => state.tab === "upcoming" ? getUpcomingEvents() : getPastEvents();

    const getFilterOptions = () => {
      const source = state.view === "calendar" ? events : getBaseEvents();
      const preferredOrder = ["Market", "Studio", "Corporate", "Private", "Pop-up"];
      const availableTypes = [];

      source.forEach((event) => {
        if (!availableTypes.includes(event.type)) {
          availableTypes.push(event.type);
        }
      });

      const orderedTypes = preferredOrder.filter((type) => availableTypes.includes(type));
      const remainingTypes = availableTypes.filter((type) => !preferredOrder.includes(type));

      return ["All", ...orderedTypes, ...remainingTypes];
    };

    const getVisibleFilter = () => {
      const options = getFilterOptions();
      return options.includes(state.typeFilter) ? state.typeFilter : "All";
    };

    const getFilteredEvents = () => {
      const filter = getVisibleFilter();
      const base = getBaseEvents();

      return filter === "All" ? base : base.filter((event) => event.type === filter);
    };

    const getCalendarEvents = () => {
      const filter = getVisibleFilter();
      return filter === "All" ? events : events.filter((event) => event.type === filter);
    };

    const getSelectedEvent = () => events.find((event) => event.id === state.selectedId) || null;

    const getEventImageModeClass = (event) => event && event.imageMode === "contain"
      ? " events-page__media--contain"
      : "";

    const getEventMediaStyle = (event) => event && event.imagePosition
      ? ` style="--events-image-position:${escapeHtml(event.imagePosition)};"`
      : "";

    const normalizeEventGalleryImages = (event) => {
      if (!event || !Array.isArray(event.galleryImages)) {
        return [];
      }

      return event.galleryImages
        .map((item) => {
          if (!item) {
            return null;
          }

          if (typeof item === "string") {
            return {
              src: item,
              alt: event.title || "Event gallery image",
              mode: "cover"
            };
          }

          if (typeof item === "object" && item.src) {
            return {
              src: item.src,
              alt: item.alt || event.title || "Event gallery image",
              mode: item.mode === "contain" ? "contain" : "cover"
            };
          }

          return null;
        })
        .filter(Boolean);
    };

    const closeModal = () => {
      state.selectedId = "";
      renderModal();
    };

    const openHostSection = () => {
      closeModal();

      const hostTarget = document.getElementById("host");
      if (hostTarget) {
        hostTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    const renderFilters = () => {
      const visibleFilter = getVisibleFilter();

      filtersNode.innerHTML = getFilterOptions().map((option) => `
        <button
          class="events-page__filter${option === visibleFilter ? " is-active" : ""}"
          type="button"
          data-events-filter="${escapeHtml(option)}"
          aria-pressed="${option === visibleFilter ? "true" : "false"}"
        >
          ${escapeHtml(option)}
        </button>
      `).join("");
    };

    const renderViewButtons = () => {
      viewButtons.forEach((button) => {
        const active = button.dataset.eventsView === state.view;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    };

    const renderTabs = () => {
      if (tabShell instanceof HTMLElement) {
        tabShell.hidden = state.view !== "list";
      }

      const counts = {
        upcoming: getUpcomingEvents().length,
        past: getPastEvents().length
      };

      tabButtons.forEach((button) => {
        const tab = button.dataset.eventsListTab;
        const active = tab === state.tab;

        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");

        if (tab && counts[tab] !== undefined) {
          button.textContent = `${tab.charAt(0).toUpperCase()}${tab.slice(1)} (${counts[tab]})`;
        }
      });
    };

    const renderCalendar = () => {
      const dateMap = {};

      getCalendarEvents().forEach((event) => {
        if (!dateMap[event.date]) {
          dateMap[event.date] = [];
        }

        dateMap[event.date].push(event);
      });

      monthLabel.textContent = state.cursor.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric"
      });

      weekdayRow.innerHTML = weekdays.map((weekday) => `<span>${weekday}</span>`).join("");

      const todayKey = ymd(today);
      const monthCells = buildMonthCells(state.cursor);

      gridNode.innerHTML = monthCells.map((cell) => {
        const key = ymd(cell);
        const dayEvents = dateMap[key] || [];
        const inMonth = cell.getMonth() === state.cursor.getMonth();
        const isTodayCell = key === todayKey;

        return `
          <div class="events-page__day-cell${inMonth ? "" : " is-outside-month"}${isTodayCell ? " is-today" : ""}">
            <span class="events-page__day-number">${cell.getDate()}</span>
            <div class="events-page__day-events">
              ${dayEvents.map((event) => `
                <button
                  class="events-page__event-pill${isUpcoming(event) ? "" : " is-past"}"
                  type="button"
                  data-event-open="${escapeHtml(event.id)}"
                  title="${escapeHtml(event.title)}"
                >
                  <span class="events-page__event-pill-dot"></span>
                  <span class="events-page__event-pill-label">${escapeHtml(event.title)}</span>
                </button>
              `).join("")}
            </div>
          </div>
        `;
      }).join("");

      gridNode.querySelectorAll("[data-event-open]").forEach((button) => {
        button.addEventListener("click", () => {
          state.selectedId = button.dataset.eventOpen || "";
          renderModal();
        });
      });
    };

    const renderList = () => {
      const filtered = getFilteredEvents();

      listView.innerHTML = filtered.map((event) => {
        const date = formatDate(event.date);
        const location = event.venue ? `${event.venue}, ${event.city}` : event.city;

        return `
          <button class="events-page__list-card" type="button" data-event-open="${escapeHtml(event.id)}">
            <div class="events-page__list-card-media${getEventImageModeClass(event)}"${getEventMediaStyle(event)}>
              <img src="${escapeHtml(event.image)}" alt="${escapeHtml(event.title)}" loading="lazy">
              <div class="events-page__list-date">
                <span>${escapeHtml(date.monthShort)}</span>
                <span>${escapeHtml(date.day)}</span>
              </div>
              ${event.soldOut ? '<span class="events-page__list-status">Sold out</span>' : ""}
            </div>
            <div class="events-page__list-card-body">
              <span class="events-page__list-type">${escapeHtml(event.type)}</span>
              <h3>${escapeHtml(event.title)}</h3>
              <p class="events-page__list-location">${escapeHtml(location)}</p>
              <p class="events-page__list-copy">${escapeHtml(event.blurb)}</p>
              ${event.sponsor ? `<p class="events-page__list-sponsor">${escapeHtml(event.sponsor)}</p>` : ""}
              <span class="events-page__list-link">${isUpcoming(event) ? "View details" : "Host something like this"} -&gt;</span>
            </div>
          </button>
        `;
      }).join("");

      listView.querySelectorAll("[data-event-open]").forEach((button) => {
        button.addEventListener("click", () => {
          state.selectedId = button.dataset.eventOpen || "";
          renderModal();
        });
      });
    };

    const initializeEventImageSlider = () => {
      const slider = modalContent.querySelector("[data-events-image-slider]");
      const track = slider && slider.querySelector("[data-events-image-track]");
      const previous = slider && slider.querySelector("[data-events-image-prev]");
      const next = slider && slider.querySelector("[data-events-image-next]");
      const current = slider && slider.querySelector("[data-events-image-current]");
      const slides = track ? Array.from(track.children) : [];

      if (!(slider instanceof HTMLElement)
        || !(track instanceof HTMLElement)
        || !(previous instanceof HTMLButtonElement)
        || !(next instanceof HTMLButtonElement)
        || !(current instanceof HTMLElement)
        || slides.length < 2) {
        return;
      }

      let activeIndex = 0;
      let syncFrame = 0;

      const syncSlider = () => {
        const width = Math.max(1, track.clientWidth);
        activeIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
        current.textContent = String(activeIndex + 1);
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;
      };

      const queueSliderSync = () => {
        if (syncFrame) {
          return;
        }

        syncFrame = window.requestAnimationFrame(() => {
          syncFrame = 0;
          syncSlider();
        });
      };

      const showSlide = (index) => {
        const targetIndex = Math.max(0, Math.min(slides.length - 1, index));
        const target = slides[targetIndex];

        if (!(target instanceof HTMLElement)) {
          return;
        }

        target.querySelectorAll("img[loading='lazy']").forEach((image) => {
          image.loading = "eager";
        });
        track.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
      };

      previous.addEventListener("click", () => showSlide(activeIndex - 1));
      next.addEventListener("click", () => showSlide(activeIndex + 1));
      track.addEventListener("scroll", queueSliderSync, { passive: true });
      track.addEventListener("keydown", (keyboardEvent) => {
        if (keyboardEvent.key === "ArrowLeft") {
          keyboardEvent.preventDefault();
          showSlide(activeIndex - 1);
        } else if (keyboardEvent.key === "ArrowRight") {
          keyboardEvent.preventDefault();
          showSlide(activeIndex + 1);
        }
      });

      syncSlider();
    };

    const renderModal = () => {
      const event = getSelectedEvent();

      if (!event) {
        modal.hidden = true;
        modalContent.innerHTML = "";
        document.body.classList.remove("events-modal-open");
        return;
      }

      const date = formatDate(event.date);
      const location = event.venue ? `${event.venue}, ${event.city}` : event.city;
      const upcoming = isUpcoming(event);
      let actionsMarkup = "";

      if (upcoming && event.href) {
        const primaryLabel = event.actionLabel || "Full details";
        actionsMarkup = `
          <a class="button" href="${escapeHtml(event.href)}">${escapeHtml(primaryLabel)}</a>
          <button class="button button--secondary" type="button" data-events-go-host>Host something like this</button>
        `;
      } else if (event.articleUrl) {
        actionsMarkup = `
          <a class="button" href="${escapeHtml(event.articleUrl)}" target="_blank" rel="noopener noreferrer">Read the recap</a>
          <button class="button button--secondary" type="button" data-events-go-host>Host something like this</button>
        `;
      } else {
        actionsMarkup = `<button class="button" type="button" data-events-go-host>${upcoming ? "Enquire about this event" : "Host something like this"}</button>`;
      }

      const contactMarkup = event.address || event.email
        ? `
          <div class="events-page__modal-contact">
            ${event.address ? `<p>${escapeHtml(event.address)}</p>` : ""}
            ${event.email ? `<p><a href="mailto:${escapeHtml(event.email)}">${escapeHtml(event.email)}</a></p>` : ""}
          </div>
        `
        : "";
      const detailsMarkup = Array.isArray(event.details) && event.details.length
        ? `
          <div class="events-page__modal-copy">
            ${event.details.map((detail) => `<p>${escapeHtml(detail)}</p>`).join("")}
          </div>
        `
        : `<p>${escapeHtml(event.blurb)}</p>`;

      const galleryImages = normalizeEventGalleryImages(event);
      const eventImages = [
        event.image
          ? {
              src: event.image,
              alt: event.title,
              mode: event.imageMode === "contain" ? "contain" : "cover",
              position: event.imagePosition || "center"
            }
          : null,
        ...galleryImages.map((image) => ({ ...image, position: "center" }))
      ].filter(Boolean);
      const modalMediaMarkup = eventImages.length > 1
        ? `
          <div class="events-page__modal-slider" data-events-image-slider>
            <div
              class="events-page__modal-slider-track"
              data-events-image-track
              tabindex="0"
              role="region"
              aria-label="Event image gallery for ${escapeHtml(event.title)}"
            >
              ${eventImages.map((image, index) => `
                <figure
                  class="events-page__modal-slide${image.mode === "contain" ? " events-page__modal-slide--contain" : ""}"
                  aria-label="Image ${index + 1} of ${eventImages.length}"
                  style="--events-image-position:${escapeHtml(image.position)};"
                >
                  <img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt)}" loading="${index === 0 ? "eager" : "lazy"}">
                </figure>
              `).join("")}
            </div>
            <div class="events-page__modal-slider-controls">
              <button class="events-page__modal-slider-button" type="button" data-events-image-prev aria-label="Show previous event image">&larr;</button>
              <span class="events-page__modal-slider-status" aria-live="polite">
                <span data-events-image-current>1</span> / ${eventImages.length}
              </span>
              <button class="events-page__modal-slider-button" type="button" data-events-image-next aria-label="Show next event image">&rarr;</button>
            </div>
          </div>
        `
        : `
          <div class="events-page__modal-media${getEventImageModeClass(event)}"${getEventMediaStyle(event)}>
            <img src="${escapeHtml(event.image)}" alt="${escapeHtml(event.title)}" loading="lazy">
          </div>
        `;

      modalContent.innerHTML = `
        ${modalMediaMarkup}
        <div class="events-page__modal-body">
          <div class="events-page__modal-status-row">
            <span class="events-page__modal-pill">${escapeHtml(event.type)}</span>
            <span class="events-page__modal-pill events-page__modal-pill--accent">${upcoming ? "Upcoming" : "Past event"}</span>
            ${event.soldOut ? '<span class="events-page__modal-pill">Sold out</span>' : ""}
          </div>
          <h2 id="events-modal-title">${escapeHtml(event.title)}</h2>
          <div class="events-page__modal-meta">
            <span>${escapeHtml(date.full)}${event.time ? ` · ${escapeHtml(event.time)}` : ""}</span>
            <span>${escapeHtml(location)}</span>
          </div>
          ${detailsMarkup}
          ${contactMarkup}
          ${event.sponsor ? `<p class="events-page__modal-sponsor">${escapeHtml(event.sponsor)}</p>` : ""}
          <div class="events-page__modal-actions">${actionsMarkup}</div>
        </div>
      `;

      modal.hidden = false;
      document.body.classList.add("events-modal-open");
      initializeEventImageSlider();

      modalContent.querySelectorAll("[data-events-go-host]").forEach((button) => {
        button.addEventListener("click", openHostSection);
      });
    };

    const render = () => {
      const visibleFilter = getVisibleFilter();
      if (visibleFilter !== state.typeFilter) {
        state.typeFilter = visibleFilter;
      }

      renderViewButtons();
      renderTabs();
      renderFilters();

      const hasListResults = getFilteredEvents().length > 0;

      calendarView.hidden = state.view !== "calendar";
      listView.hidden = state.view !== "list" || !hasListResults;
      emptyState.hidden = state.view !== "list" || hasListResults;

      renderCalendar();
      renderList();
      renderModal();
    };

    viewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        state.view = button.dataset.eventsView === "list" ? "list" : "calendar";
        render();
      });
    });

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        state.tab = button.dataset.eventsListTab === "past" ? "past" : "upcoming";
        render();
      });
    });

    filtersNode.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-events-filter]");
      if (!(trigger instanceof HTMLElement)) {
        return;
      }

      state.typeFilter = trigger.dataset.eventsFilter || "All";
      render();
    });

    if (prevButton instanceof HTMLButtonElement) {
      prevButton.addEventListener("click", () => {
        state.cursor = new Date(state.cursor.getFullYear(), state.cursor.getMonth() - 1, 1);
        renderCalendar();
      });
    }

    if (nextButton instanceof HTMLButtonElement) {
      nextButton.addEventListener("click", () => {
        state.cursor = new Date(state.cursor.getFullYear(), state.cursor.getMonth() + 1, 1);
        renderCalendar();
      });
    }

    if (todayButton instanceof HTMLButtonElement) {
      todayButton.addEventListener("click", () => {
        state.cursor = new Date(today.getFullYear(), today.getMonth(), 1);
        renderCalendar();
      });
    }

    modal.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-events-modal-close]");
      if (trigger) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    render();
  });

  document.querySelectorAll("[data-events-host]").forEach((root) => {
    const form = root.querySelector("form");
    const typeInput = root.querySelector("[data-events-type-input]");
    const typeButtons = Array.from(root.querySelectorAll("[data-events-type-option]"));
    const summaryFormat = root.querySelector("[data-events-summary-format]");
    const summaryDate = root.querySelector("[data-events-summary-date]");
    const summaryGuests = root.querySelector("[data-events-summary-guests]");
    const summaryLocation = root.querySelector("[data-events-summary-location]");

    if (
      !(form instanceof HTMLFormElement)
      || !(typeInput instanceof HTMLInputElement)
      || !(summaryFormat instanceof HTMLElement)
      || !(summaryDate instanceof HTMLElement)
      || !(summaryGuests instanceof HTMLElement)
      || !(summaryLocation instanceof HTMLElement)
    ) {
      return;
    }

    const dateField = form.querySelector("[name='contact[Preferred Date]']");
    const guestsField = form.querySelector("[name='contact[Guests]']");
    const cityField = form.querySelector("[name='contact[City]']");

    const setSummaryValue = (node, value, fallback) => {
      node.textContent = value || fallback;
      node.classList.toggle("is-empty", !value);
    };

    const syncTypeCards = () => {
      typeButtons.forEach((button) => {
        button.classList.toggle("is-active", button.dataset.eventsTypeOption === typeInput.value);
      });
    };

    const syncSummary = () => {
      const parsedDate = dateField instanceof HTMLInputElement && dateField.value
        ? new Date(`${dateField.value}T00:00:00`)
        : null;
      const formattedDate = parsedDate
        ? parsedDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })
        : "";
      const guestsValue = guestsField instanceof HTMLInputElement && guestsField.value
        ? `${guestsField.value} people`
        : "";
      const cityValue = cityField instanceof HTMLInputElement ? cityField.value.trim() : "";

      setSummaryValue(summaryFormat, typeInput.value.trim(), "To be decided");
      setSummaryValue(summaryDate, formattedDate, "To be decided");
      setSummaryValue(summaryGuests, guestsValue, "To be decided");
      setSummaryValue(summaryLocation, cityValue, "To be decided");
      syncTypeCards();
    };

    typeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        typeInput.value = button.dataset.eventsTypeOption || "";
        syncSummary();
      });
    });

    form.addEventListener("input", syncSummary);
    form.addEventListener("change", syncSummary);

    const nativeReset = form.reset.bind(form);
    form.reset = () => {
      nativeReset();
      window.setTimeout(syncSummary, 0);
    };

    syncSummary();
  });

  document.querySelectorAll("[data-lead-form-root]").forEach((root) => {
    const form = root.querySelector("form");
    if (!form) return;

    const apiBase = (root.dataset.apiBase || "").trim().replace(/\/$/, "");
    const source = root.dataset.source || "";
    const interest = root.dataset.interest || "";
    const successMessage = root.querySelector("[data-lead-success]");
    const errorMessage = root.querySelector("[data-lead-error]");
    const submitButton = form.querySelector("[data-lead-submit]");
    const detailsField = form.querySelector("input[name='contact[Details]']");
    const defaultSuccessMessage = successMessage ? successMessage.textContent.trim() : "";
    const fallbackStatuses = new Set([401, 403, 404, 405]);
    let nativeFallbackTriggered = false;

    const getFieldValue = (selector) => {
      const field = form.querySelector(selector);
      if (
        field instanceof HTMLInputElement
        || field instanceof HTMLTextAreaElement
        || field instanceof HTMLSelectElement
      ) {
        return field.value.trim();
      }

      return "";
    };

    const setStatus = (node, message) => {
      if (!node) return;
      if (!message) {
        node.hidden = true;
        node.textContent = "";
        return;
      }

      node.hidden = false;
      node.textContent = message;
    };

    const shouldFallbackToShopify = (status) => status >= 500 || fallbackStatuses.has(status);

    const submitNativeFallback = () => {
      nativeFallbackTriggered = true;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Submitting...";
      }

      form.submit();
    };

    form.addEventListener("submit", async (event) => {
      if (nativeFallbackTriggered) {
        nativeFallbackTriggered = false;
        return;
      }

      const organization = getFieldValue("[name='contact[Organization]']");
      const preferredDate = getFieldValue("[name='contact[Preferred Date]']");
      const subject = getFieldValue("[name='contact[Subject]']");
      const message = getFieldValue("[name='contact[body]']");
      const phone = getFieldValue("[name='contact[phone]']");
      const company = getFieldValue("[name='company']");
      const email = getFieldValue("[name='contact[email]']");
      const name = getFieldValue("[name='contact[name]']") || getFieldValue("[name='contact[Name]']");
      const interestValue = getFieldValue("[name='contact[Interest]']") || interest;

      const details = {};
      if (interestValue) details.interest = interestValue;
      if (organization) details.organisation = organization;
      if (preferredDate) details.date = preferredDate;
      if (subject) details.subject = subject;
      form.querySelectorAll("[data-lead-details-key]").forEach((field) => {
        const key = field.dataset.leadDetailsKey;
        const value = typeof field.value === "string" ? field.value.trim() : "";

        if (key && value) {
          details[key] = value;
        }
      });
      details.page_path = window.location.pathname;
      details.page_url = window.location.href;
      details.page_title = document.title;
      if (form.id) {
        details.form_id = form.id;
      }

      if (detailsField) {
        detailsField.value = JSON.stringify(details);
      }

      setStatus(successMessage, "");
      setStatus(errorMessage, "");

      if (company) {
        event.preventDefault();
        return;
      }

      if (!apiBase) {
        return;
      }

      event.preventDefault();

      const originalLabel = submitButton ? submitButton.textContent : "";
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Sending...";
      }

      try {
        const response = await fetch(`${apiBase}/api/lead-submissions`, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            source,
            email,
            name,
            phone,
            message,
            details: JSON.stringify(details),
            company
          })
        });

        if (!response.ok) {
          if (shouldFallbackToShopify(response.status)) {
            submitNativeFallback();
            return;
          }

          throw new Error(`Lead submission failed with status ${response.status}`);
        }

        form.reset();
        if (detailsField) {
          detailsField.value = "";
        }
        setStatus(
          successMessage,
          defaultSuccessMessage || "Thanks. We received your note and will be in touch soon."
        );
      } catch (error) {
        if (error instanceof TypeError) {
          submitNativeFallback();
          return;
        }

        setStatus(
          errorMessage,
          "We couldn't send that just now. Please try again, or contact us directly."
        );
      } finally {
        if (submitButton && !nativeFallbackTriggered) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
      }
    });
  });

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizeShareUrl(value) {
    const fallback = window.location.href;
    const raw = String(value || "").trim();

    if (!raw) {
      return fallback;
    }

    try {
      return new URL(raw, window.location.origin).toString();
    } catch (error) {
      return fallback;
    }
  }

  function setShareStatus(root, message) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    const status = root.querySelector("[data-share-status]");
    if (!(status instanceof HTMLElement)) {
      return;
    }

    status.textContent = message || "";

    if (root.shareStatusTimer) {
      window.clearTimeout(root.shareStatusTimer);
    }

    if (message) {
      root.shareStatusTimer = window.setTimeout(() => {
        status.textContent = "";
      }, 2200);
    }
  }

  function buildCartShareUrl(root) {
    const shopifyRoot = window.Shopify?.routes?.root || "/";
    const normalizedRoot = shopifyRoot.endsWith("/") ? shopifyRoot : `${shopifyRoot}/`;
    const fallbackPath = String(root?.dataset.shareUrl || `${normalizedRoot}cart`);
    const source =
      root?.closest("[data-cart-drawer]") ||
      root?.closest(".cart-page") ||
      document.querySelector(".cart-page") ||
      document.querySelector("[data-cart-drawer]");

    if (!(source instanceof HTMLElement)) {
      return normalizeShareUrl(fallbackPath);
    }

    const lineItems = [];

    if (source.hasAttribute("data-cart-drawer")) {
      source.querySelectorAll("[data-cart-item]").forEach((item) => {
        const variantId = Number(item.getAttribute("data-cart-variant-id") || 0);
        const quantity = Number(item.getAttribute("data-cart-quantity") || 0);

        if (variantId > 0 && quantity > 0) {
          lineItems.push(`${variantId}:${quantity}`);
        }
      });
    } else {
      source.querySelectorAll("[data-cart-page-line]").forEach((item) => {
        const variantId = Number(item.getAttribute("data-cart-variant-id") || 0);
        const quantityInput = item.querySelector("[data-cart-page-input]");
        const quantity = Number(quantityInput instanceof HTMLInputElement ? quantityInput.value : 0);

        if (variantId > 0 && quantity > 0) {
          lineItems.push(`${variantId}:${quantity}`);
        }
      });
    }

    if (!lineItems.length) {
      return normalizeShareUrl(fallbackPath);
    }

    return normalizeShareUrl(`${normalizedRoot}cart/${lineItems.join(",")}`);
  }

  function buildSharePayload(root) {
    const useLocation = root?.dataset.shareUseLocation === "true";
    const mode = root?.dataset.shareMode || "page";
    const title = String(root?.dataset.shareTitle || document.title || "Wellness Route").trim();
    const text = String(root?.dataset.shareText || title).trim();
    let url = useLocation
      ? window.location.href
      : normalizeShareUrl(root?.dataset.shareUrl || window.location.href);

    if (mode === "cart") {
      url = buildCartShareUrl(root);
    }

    return {
      title,
      text,
      url
    };
  }

  function buildShareActionTarget(action, payload) {
    const url = encodeURIComponent(payload.url);
    const title = encodeURIComponent(payload.title);
    const combinedText = encodeURIComponent(
      payload.text && payload.text !== payload.title
        ? `${payload.title} — ${payload.text}`
        : payload.title
    );
    const longBody = encodeURIComponent(
      payload.text && payload.text !== payload.title
        ? `${payload.title}\n\n${payload.text}\n\n${payload.url}`
        : `${payload.title}\n\n${payload.url}`
    );

    switch (action) {
      case "email":
        return `mailto:?subject=${title}&body=${longBody}`;
      case "text":
        return `sms:?&body=${longBody}`;
      case "whatsapp":
        return `https://api.whatsapp.com/send?text=${longBody}`;
      case "facebook":
        return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      case "twitter":
        return `https://twitter.com/intent/tweet?text=${combinedText}&url=${url}`;
      case "linkedin":
        return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
      case "pinterest":
        return `https://pinterest.com/pin/create/button/?url=${url}&description=${combinedText}`;
      default:
        return "";
    }
  }

  async function copyShareLink(root, payload) {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(payload.url);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = payload.url;
        textArea.setAttribute("readonly", "");
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }

      setShareStatus(root, "Link copied.");
    } catch (error) {
      setShareStatus(root, "Copy failed. Please try again.");
    }
  }

  function syncShareSheets(scope) {
    const rootNode = scope instanceof Element || scope instanceof Document ? scope : document;

    rootNode.querySelectorAll("[data-share-root]").forEach((root) => {
      if (!(root instanceof HTMLDetailsElement)) {
        return;
      }

      const nativeButton = root.querySelector("[data-share-action='native']");

      if (nativeButton instanceof HTMLElement) {
        nativeButton.hidden = !(navigator.share instanceof Function);
      }

      if (root.dataset.shareReady === "true") {
        return;
      }

      root.dataset.shareReady = "true";
      root.addEventListener("toggle", () => {
        if (!root.open) {
          return;
        }

        document.querySelectorAll("[data-share-root][open]").forEach((other) => {
          if (other !== root && other instanceof HTMLDetailsElement) {
            other.open = false;
          }
        });
      });
    });
  }

  document.querySelectorAll("[data-route-gallery]").forEach((root) => {
    const grid = root.querySelector("[data-route-gallery-grid]");
    const countNode = root.querySelector("[data-route-gallery-count]");
    const emptyNode = root.querySelector("[data-route-gallery-empty]");
    const sortNode = root.querySelector("[data-route-gallery-sort]");
    const cards = Array.from(root.querySelectorAll("[data-route-gallery-card]"));
    const filterButtons = Array.from(root.querySelectorAll("[data-route-gallery-filter]"));

    if (
      !(grid instanceof HTMLElement)
      || !(countNode instanceof HTMLElement)
      || !(emptyNode instanceof HTMLElement)
      || !(sortNode instanceof HTMLSelectElement)
      || !cards.length
      || !filterButtons.length
    ) {
      return;
    }

    const state = {
      filter: "all",
      sort: sortNode.value || "featured"
    };

    const parseDate = (value) => {
      if (!value) {
        return 0;
      }

      const timestamp = Date.parse(`${value}T00:00:00`);

      return Number.isNaN(timestamp) ? 0 : timestamp;
    };

    const applyState = () => {
      const visibleCards = cards
        .filter((card) => {
          if (state.filter === "all") {
            return true;
          }

          const categories = (card.dataset.categories || "").split("|").filter(Boolean);

          return categories.includes(state.filter);
        })
        .sort((left, right) => {
          if (state.sort === "az") {
            return (left.dataset.title || "").localeCompare(right.dataset.title || "");
          }

          if (state.sort === "newest") {
            const dateDelta = parseDate(right.dataset.date) - parseDate(left.dataset.date);

            if (dateDelta !== 0) {
              return dateDelta;
            }
          }

          return Number(left.dataset.order || 0) - Number(right.dataset.order || 0);
        });

      cards.forEach((card) => {
        card.hidden = true;
      });

      visibleCards.forEach((card) => {
        card.hidden = false;
        grid.appendChild(card);
      });

      countNode.textContent = `${visibleCards.length} ${visibleCards.length === 1 ? "moment" : "moments"}`;
      emptyNode.hidden = visibleCards.length > 0;

      filterButtons.forEach((button) => {
        const active = button.dataset.routeGalleryFilter === state.filter;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    };

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        state.filter = button.dataset.routeGalleryFilter || "all";
        applyState();
      });
    });

    sortNode.addEventListener("change", () => {
      state.sort = sortNode.value || "featured";
      applyState();
    });

    applyState();
  });

  window.WellnessRoute = window.WellnessRoute || {};
  window.WellnessRoute.syncShareSheets = syncShareSheets;

  syncShareSheets(document);

  document.addEventListener("click", async (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const actionTrigger = target.closest("[data-share-action]");

    if (!actionTrigger) {
      if (!target.closest("[data-share-root]")) {
        document.querySelectorAll("[data-share-root][open]").forEach((root) => {
          if (root instanceof HTMLDetailsElement) {
            root.open = false;
          }
        });
      }
      return;
    }

    event.preventDefault();

    const shareRoot = actionTrigger.closest("[data-share-root]");

    if (!(shareRoot instanceof HTMLDetailsElement)) {
      return;
    }

    const action = actionTrigger.getAttribute("data-share-action") || "";
    const payload = buildSharePayload(shareRoot);

    if (action === "copy") {
      await copyShareLink(shareRoot, payload);
      shareRoot.open = false;
      return;
    }

    if (action === "native") {
      if (!(navigator.share instanceof Function)) {
        setShareStatus(shareRoot, "More share options are not available on this device.");
        return;
      }

      try {
        await navigator.share(payload);
      } catch (error) {
        if (error && error.name === "AbortError") {
          return;
        }
      } finally {
        shareRoot.open = false;
      }

      return;
    }

    const destination = buildShareActionTarget(action, payload);

    if (!destination) {
      return;
    }

    if (action === "email" || action === "text") {
      window.location.href = destination;
    } else {
      window.open(destination, "_blank", "noopener,noreferrer,width=720,height=720");
    }

    shareRoot.open = false;
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") {
      return;
    }

    document.querySelectorAll("[data-share-root][open]").forEach((root) => {
      if (root instanceof HTMLDetailsElement) {
        root.open = false;
      }
    });
  });

  document.querySelectorAll("[data-quiz-app]").forEach((root) => {
    const payloadNode = root.querySelector("[data-quiz-payload]");
    const stage = root.querySelector("[data-quiz-stage]");
    const results = root.querySelector("[data-quiz-results]");
    const progressLabel = root.querySelector("[data-quiz-progress-label]");
    const progressValue = root.querySelector("[data-quiz-progress-value]");
    const progressBar = root.querySelector("[data-quiz-progress-bar]");
    const stepEyebrow = root.querySelector("[data-quiz-step-eyebrow]");
    const questionTitle = root.querySelector("[data-quiz-question-title]");
    const questionSub = root.querySelector("[data-quiz-question-sub]");
    const optionsNode = root.querySelector("[data-quiz-options]");
    const selectionNote = root.querySelector("[data-quiz-selection-note]");
    const backButton = root.querySelector("[data-quiz-back]");
    const nextButton = root.querySelector("[data-quiz-next]");
    const restartButton = root.querySelector("[data-quiz-restart]");
    const resultsHeading = root.querySelector("[data-quiz-results-heading]");
    const summaryNode = root.querySelector("[data-quiz-summary]");
    const collectionResults = root.querySelector("[data-quiz-collections]");
    const productResults = root.querySelector("[data-quiz-products]");

    if (
      !payloadNode ||
      !stage ||
      !results ||
      !progressLabel ||
      !progressValue ||
      !progressBar ||
      !stepEyebrow ||
      !questionTitle ||
      !questionSub ||
      !optionsNode ||
      !backButton ||
      !nextButton ||
      !restartButton ||
      !resultsHeading ||
      !summaryNode ||
      !collectionResults ||
      !productResults
    ) {
      return;
    }

    let payload;

    try {
      payload = JSON.parse(payloadNode.textContent || "{}");
    } catch (error) {
      return;
    }

    const questions = Array.isArray(payload.questions) ? payload.questions : [];
    const collections = payload.collections && typeof payload.collections === "object"
      ? payload.collections
      : {};
    const storageKey = root.dataset.quizStorageKey || "wellness-route-quiz-state";
    const isMultiQuestion = (question) => Boolean(question?.multi);
    const getMaxSelections = (question) => {
      const maxSelections = Number(question?.maxSelections);
      return Number.isInteger(maxSelections) && maxSelections > 0
        ? maxSelections
        : question?.options?.length || 1;
    };
    const createEmptyAnswers = () => questions.map((question) => (
      isMultiQuestion(question) ? [] : null
    ));
    const getAnswerIndexes = (question, answer) => {
      if (isMultiQuestion(question)) {
        return Array.isArray(answer)
          ? answer.filter((value) => Number.isInteger(value))
          : [];
      }

      return Number.isInteger(answer) ? [answer] : [];
    };
    const hasAnsweredQuestion = (question, answer) => getAnswerIndexes(question, answer).length > 0;
    const state = {
      step: 0,
      answers: createEmptyAnswers(),
      done: false,
      selectionMessage: "",
      calibrating: false
    };

    if (!questions.length) {
      return;
    }

    const saveState = () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {
        // Ignore storage failures and keep the quiz functional.
      }
    };

    const restoreState = () => {
      try {
        const raw = sessionStorage.getItem(storageKey);
        if (!raw) return;

        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed.answers) || parsed.answers.length !== questions.length) {
          return;
        }

        state.step = Number.isInteger(parsed.step) ? parsed.step : 0;
        state.step = Math.min(Math.max(state.step, 0), Math.max(questions.length - 1, 0));
        state.answers = parsed.answers.map((value, index) => {
          const question = questions[index];

          if (isMultiQuestion(question)) {
            if (Array.isArray(value)) {
              return value
                .filter((entry) => Number.isInteger(entry))
                .slice(0, getMaxSelections(question));
            }

            return Number.isInteger(value) ? [value] : [];
          }

          if (Number.isInteger(value)) return value;
          if (Array.isArray(value) && Number.isInteger(value[0])) return value[0];
          return null;
        });
        state.done = Boolean(parsed.done);
      } catch (error) {
        // Ignore invalid saved quiz state.
      }
    };

    const clearState = () => {
      try {
        sessionStorage.removeItem(storageKey);
      } catch (error) {
        // Ignore storage failures and keep the quiz functional.
      }
    };

    const getScores = () => {
      const scores = {};

      state.answers.forEach((answerValue, questionIndex) => {
        const question = questions[questionIndex];
        const weight = Number(question?.weight) || 1;
        const answerIndexes = getAnswerIndexes(question, answerValue);
        if (!answerIndexes.length) return;

        const distributedWeight = weight / answerIndexes.length;

        answerIndexes.forEach((optionIndex) => {
          const option = question?.options?.[optionIndex];
          if (!option || !Array.isArray(option.collections)) return;

          option.collections.forEach((slug) => {
            scores[slug] = (scores[slug] || 0) + distributedWeight;
          });
        });
      });

      return scores;
    };

    const getRankedCollections = () => (
      Object.entries(getScores())
        .sort((left, right) => right[1] - left[1])
        .map(([slug]) => slug)
    );

    const getTopCollections = () => (
      getRankedCollections()
        .map((slug) => collections[slug])
        .filter(Boolean)
        .slice(0, 3)
    );

    const getRecommendedProducts = () => {
      const rankedCollections = getRankedCollections();
      const seenHandles = new Set();
      const picks = [];

      rankedCollections.forEach((slug) => {
        const products = Array.isArray(collections[slug]?.products)
          ? collections[slug].products
          : [];

        products.forEach((product) => {
          if (picks.length >= 4 || seenHandles.has(product.handle)) {
            return;
          }

          seenHandles.add(product.handle);
          picks.push(product);
        });
      });

      return picks;
    };

    const getSelectedLabels = () => {
      const labels = [];

      state.answers.forEach((answerValue, questionIndex) => {
        const question = questions[questionIndex];
        getAnswerIndexes(question, answerValue).forEach((optionIndex) => {
          const label = question?.options?.[optionIndex]?.label;
          if (label) labels.push(label);
        });
      });

      return labels;
    };

    const renderQuestionOptions = () => {
      const question = questions[state.step];

      if (!question) return;

      const selectedIndexes = getAnswerIndexes(question, state.answers[state.step]);
      const selectedSet = new Set(selectedIndexes);
      const maxSelections = getMaxSelections(question);
      const atLimit = isMultiQuestion(question) && selectedIndexes.length >= maxSelections;

      optionsNode.innerHTML = question.options.map((option, index) => {
        const active = selectedSet.has(index);

        return `
          <button
            class="quiz-option${active ? " is-active" : ""}${atLimit && !active ? " is-capped" : ""}"
            type="button"
            data-quiz-option="${index}"
            aria-pressed="${active ? "true" : "false"}"
          >
            <span>${escapeHtml(option.label)}</span>
            <span class="quiz-option__arrow" aria-hidden="true">${active ? "✓" : isMultiQuestion(question) ? "+" : "→"}</span>
          </button>
        `;
      }).join("");
    };

    const renderSelectionNote = () => {
      if (!selectionNote) return;

      const question = questions[state.step];
      const selectedCount = getAnswerIndexes(question, state.answers[state.step]).length;

      selectionNote.classList.toggle("is-warning", Boolean(state.selectionMessage));

      if (state.selectionMessage) {
        selectionNote.textContent = state.selectionMessage;
        return;
      }

      if (isMultiQuestion(question)) {
        const maxSelections = getMaxSelections(question);
        selectionNote.textContent = selectedCount
          ? `${selectedCount} selected. Choose up to ${maxSelections}, then continue.`
          : `Select up to ${maxSelections}, then continue.`;
        return;
      }

      selectionNote.textContent = state.step === questions.length - 1
        ? "Choose one answer, then tap Calibrate my results."
        : "Choose one answer, then continue.";
    };

    const renderCollectionResults = () => {
      const topCollections = getTopCollections();

      if (!topCollections.length) {
        collectionResults.innerHTML = `
          <div class="info-panel">
            <p class="eyebrow">No route yet</p>
            <h3>Finish the quiz to unlock your route.</h3>
          </div>
        `;
        return;
      }

      collectionResults.innerHTML = topCollections.map((collection) => `
        <a class="page-card page-card--link quiz-route-card" href="${escapeHtml(collection.url || "#")}">
          ${collection.image ? `
            <div class="page-card__media">
              <img src="${escapeHtml(collection.image)}" alt="${escapeHtml(collection.title)}" loading="lazy">
            </div>
          ` : ""}
          <p class="page-card__kicker">${escapeHtml(collection.tagline || "Recommended route")}</p>
          <h3>${escapeHtml(collection.title)}</h3>
          <p>${escapeHtml(collection.description || "")}</p>
          <p class="quiz-route-card__meta">${escapeHtml(String(collection.count || 0))} ${(collection.count || 0) === 1 ? "product" : "products"}</p>
        </a>
      `).join("");
    };

    const renderProductResults = () => {
      const recommendedProducts = getRecommendedProducts();

      if (!recommendedProducts.length) {
        productResults.innerHTML = `
          <div class="info-panel">
            <p class="eyebrow">Nothing matched yet</p>
            <h3>We will recommend products as soon as your route is ready.</h3>
          </div>
        `;
        return;
      }

      productResults.innerHTML = recommendedProducts.map((product) => `
        <div class="collection-product-card">
          <div class="featured-card featured-card--product">
            <a class="featured-card__media-link" href="${escapeHtml(product.url || "#")}">
              <div class="featured-card__image">
                ${product.image ? `
                  <img
                    class="featured-card__primary-image"
                    src="${escapeHtml(product.image)}"
                    alt="${escapeHtml(product.title)}"
                    loading="lazy"
                  >
                ` : `
                  <div class="media-placeholder">${escapeHtml(product.title)}</div>
                `}
              </div>
            </a>
            <div class="featured-card__body featured-card__body--product">
              <div class="featured-card__copy">
                ${product.vendor ? `<p class="featured-card__brand">${escapeHtml(product.vendor)}</p>` : ""}
                <h3><a class="featured-card__title-link" href="${escapeHtml(product.url || "#")}">${escapeHtml(product.title)}</a></h3>
              </div>
              <div class="featured-card__footer">
                <div class="price-stack">
                  ${product.price ? `<span class="price-stack__current">${escapeHtml(product.price)}</span>` : ""}
                  ${product.comparePrice ? `<span class="price-stack__compare">${escapeHtml(product.comparePrice)}</span>` : ""}
                </div>
                <a class="featured-card__quick-add featured-card__quick-add--link" href="${escapeHtml(product.url || "#")}">View</a>
              </div>
            </div>
          </div>
        </div>
      `).join("");
    };

    const renderSelectedSummary = () => {
      const labels = getSelectedLabels();

      if (!labels.length) {
        summaryNode.hidden = true;
        summaryNode.innerHTML = "";
        return;
      }

      summaryNode.hidden = false;
      summaryNode.innerHTML = `
        <p class="quiz-summary__label">Based on what you selected</p>
        ${labels.map((label) => `<span class="quiz-summary__pill">${escapeHtml(label)}</span>`).join("")}
      `;
    };

    const render = () => {
      const progress = ((state.done ? questions.length : state.step + 1) / questions.length) * 100;

      progressLabel.textContent = state.done
        ? "Quiz complete"
        : `Question ${state.step + 1} of ${questions.length}`;
      progressValue.textContent = `${Math.round(progress)}%`;
      progressBar.style.width = `${progress}%`;

      if (state.done) {
        stage.hidden = true;
        results.hidden = false;
        nextButton.hidden = true;
        renderCollectionResults();
        renderProductResults();
        renderSelectedSummary();
      } else {
        const question = questions[state.step];

        stage.hidden = false;
        results.hidden = true;
        nextButton.hidden = false;
        stepEyebrow.textContent = `Question ${state.step + 1}`;
        questionTitle.textContent = question.q || "";
        questionSub.textContent = question.sub || "";
        backButton.hidden = state.step === 0;
        nextButton.disabled = !hasAnsweredQuestion(question, state.answers[state.step]) || state.calibrating;
        nextButton.textContent = state.calibrating
          ? "Calibrating your results..."
          : state.step === questions.length - 1
          ? "Calibrate my results"
          : "Continue";
        renderQuestionOptions();
        renderSelectionNote();
      }

      saveState();
    };

    const revealResults = () => {
      state.calibrating = true;
      render();

      window.setTimeout(() => {
        state.done = true;
        state.calibrating = false;
        render();
        results.scrollIntoView({ behavior: "smooth", block: "start" });
        resultsHeading.focus({ preventScroll: true });
      }, 320);
    };

    const advanceQuiz = () => {
      const question = questions[state.step];
      if (!hasAnsweredQuestion(question, state.answers[state.step])) return;

      if (state.step < questions.length - 1) {
        state.step += 1;
        state.selectionMessage = "";
        stage.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        revealResults();
        return;
      }

      render();
    };

    const chooseOption = (optionIndex) => {
      const question = questions[state.step];
      if (!question) return;

      if (isMultiQuestion(question)) {
        const currentSelection = getAnswerIndexes(question, state.answers[state.step]);
        const isSelected = currentSelection.includes(optionIndex);

        if (isSelected) {
          state.answers[state.step] = currentSelection.filter((value) => value !== optionIndex);
          state.selectionMessage = "";
          render();
          return;
        }

        if (currentSelection.length >= getMaxSelections(question)) {
          state.selectionMessage = `You can choose up to ${getMaxSelections(question)} here. Tap one again to remove it.`;
          render();
          return;
        }

        state.answers[state.step] = [...currentSelection, optionIndex];
        state.selectionMessage = "";
        render();
        return;
      }

      state.answers[state.step] = optionIndex;
      state.selectionMessage = "";
      render();
    };

    const restartQuiz = () => {
      state.step = 0;
      state.done = false;
      state.answers = createEmptyAnswers();
      state.selectionMessage = "";
      state.calibrating = false;
      clearState();
      render();
      stage.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    optionsNode.addEventListener("click", (event) => {
      const button = event.target.closest("[data-quiz-option]");
      if (!button) return;

      const optionIndex = Number.parseInt(button.dataset.quizOption || "", 10);
      if (Number.isNaN(optionIndex)) return;

      chooseOption(optionIndex);
    });

    backButton.addEventListener("click", () => {
      if (state.step === 0) return;
      state.step -= 1;
      state.done = false;
      state.selectionMessage = "";
      render();
    });

    nextButton.addEventListener("click", advanceQuiz);
    restartButton.addEventListener("click", restartQuiz);

    restoreState();
    render();
  });

  const CATEGORY_GROUPS = [
    {
      slug: "skincare-beauty",
      title: "Skincare & Beauty",
      subcategories: [
        { slug: "face-care", title: "Face Care" },
        { slug: "body-care", title: "Body Care" },
        { slug: "hair-care", title: "Hair Care" },
        { slug: "makeup", title: "Makeup" },
        { slug: "beauty-tools", title: "Beauty Tools & Accessories" },
        { slug: "self-care-kits", title: "Self-Care Kits" }
      ]
    },
    {
      slug: "home-spa-outfitting",
      title: "Home Spa Outfitting",
      subcategories: [
        { slug: "saunas", title: "Saunas" },
        { slug: "cold-plunges", title: "Cold Plunges" },
        { slug: "massage-chairs", title: "Massage Chairs" },
        { slug: "led-light-therapy", title: "Red Light & LED" },
        { slug: "massagers", title: "Massagers" },
        { slug: "wellness-decor", title: "Wellness & Decor" }
      ]
    },
    {
      slug: "for-the-office",
      title: "For The Office",
      subcategories: [
        { slug: "desk-wellness", title: "Desk Wellness" },
        { slug: "office-light-therapy", title: "Light Therapy" },
        { slug: "office-installs", title: "Office Installs" }
      ]
    }
  ];

  const CATEGORY_LABELS = CATEGORY_GROUPS.reduce((lookup, group) => {
    group.subcategories.forEach((subcategory) => {
      lookup[subcategory.slug] = subcategory.title;
    });
    return lookup;
  }, {});

  const CANONICAL_BRANDS = [
    { slug: "the-wellness-route", title: "The Wellness Route" },
    { slug: "innersense", title: "Innersense" },
    { slug: "hadaka", title: "Hadaka" },
    { slug: "dear-derm", title: "Dear Derm" },
    { slug: "go-simple-naturals", title: "Go Simple Naturals" }
  ];

  const BRAND_LABELS = CANONICAL_BRANDS.reduce((lookup, brand) => {
    lookup[brand.slug] = brand.title;
    return lookup;
  }, {});

  const FACET_DEFS = [
    { id: "type", title: "Product type" },
    { id: "concern", title: "Skin concern" },
    { id: "formula", title: "Formula" }
  ];

  const TYPE_RULES = [
    { label: "Cleanser", patterns: [/\bcleanser\b/, /\bcleanse\b/, /\bcleansing\b/, /makeup remover/, /makeup eras/, /\bface wash\b/] },
    { label: "Toner & Mist", patterns: [/\btoner\b/, /\bmist\b/, /\btonic\b/] },
    { label: "Serum & Essence", patterns: [/\bserum\b/, /\bessence\b/, /\bampoule\b/] },
    { label: "Face Oil", patterns: [/\bface oil\b/, /\bfacial oil\b/, /\bfaceoil\b/] },
    { label: "Moisturizer", patterns: [/\bmoisturiz/, /\bmoisturis/, /\bday cream\b/, /\bnight cream\b/, /\bcream\b/, /\bwhip\b/] },
    { label: "Treatment Mask", patterns: [/\bmask\b/, /\bsheet mask\b/, /hydro dot/, /hydrodot/] },
    { label: "Eye Care", patterns: [/\beye mask\b/, /under eye/, /eye patch/, /eye patches/, /eye roller/, /eye treatment/] },
    { label: "Exfoliant & Scrub", patterns: [/\bscrub\b/, /\bexfoliat/, /microderm/, /\bpeel\b/, /dry brush/] },
    { label: "Balm", patterns: [/\bbalm\b/] },
    { label: "Lip Care", patterns: [/\blip\b/] },
    { label: "Mascara & Lash", patterns: [/\bmascara\b/, /\blash\b/, /\bbrow\b/] },
    { label: "Tool & Device", patterns: [/gua sha/, /\broller\b/, /\bled\b/, /\bdevice\b/, /micro current/, /microcurrent/, /\bsculpt/, /\bcupping\b/] },
    { label: "Hair Care", patterns: [/shampoo/, /conditioner/, /hairbath/, /hair mask/, /hair oil/, /\bscalp\b/] },
    { label: "Body & Bath", patterns: [/body wash/, /body butter/, /body scrub/, /\bbutter\b/, /\bsoap\b/, /\bbath\b/] }
  ];

  const CONCERN_RULES = [
    { label: "Acne & blemishes", patterns: [/\bacne\b/, /blemish/, /breakout/, /pimple/, /\bspot\b/, /hydro dot/, /hydrodot/, /clear it/, /clarify/] },
    { label: "Redness & sensitivity", patterns: [/rosacea/, /redness/, /sensitive/, /\bcalm/, /soothe/, /soothing/] },
    { label: "Dryness & hydration", patterns: [/hydrat/, /\bhyaluronic\b/, /\bmoistur/, /\bdewy\b/, /\bplump/] },
    { label: "Dullness & brightening", patterns: [/brighten/, /\bvitamin c\b/, /illuminat/, /\bluminous\b/, /dark spot/, /even tone/] },
    { label: "Fine lines & firmness", patterns: [/retinol/, /collagen/, /\bfirm/, /\blift/, /wrinkle/, /anti aging/, /\bpeptide/, /rejuvenat/, /\brenew\b/] },
    { label: "Oiliness & pores", patterns: [/mattif/, /oil control/, /charcoal/, /\bpore/, /\bsebum/, /\boily\b/, /\bniacinamide\b/] },
    { label: "Puffiness & eye area", patterns: [/depuff/, /de puff/, /under eye/, /dark circle/, /\beye mask\b/, /eye patch/, /eye treatment/] }
  ];

  const FORMULA_RULES = [
    { label: "Cream", patterns: [/\bcream\b/, /\bwhip\b/] },
    { label: "Lotion", patterns: [/\blotion\b/] },
    { label: "Butter", patterns: [/\bbutter\b/] },
    { label: "Oil", patterns: [/\boil\b/] },
    { label: "Balm", patterns: [/\bbalm\b/] },
    { label: "Gel", patterns: [/\bgel\b/, /hydrogel/] },
    { label: "Spray & Mist", patterns: [/\bspray\b/, /\bmist\b/] },
    { label: "Sheet Mask", patterns: [/sheet mask/] },
    { label: "Patch", patterns: [/\bpatch\b/, /\bpatches\b/, /hydro dot/, /hydrodot/] },
    { label: "Scrub & Powder", patterns: [/\bscrub\b/, /\bpowder\b/] },
    { label: "Bar & Soap", patterns: [/\bsoap\b/, /\bsponge\b/] }
  ];

  const FACET_OPTION_ORDER = {
    type: TYPE_RULES.map((rule) => rule.label),
    concern: CONCERN_RULES.map((rule) => rule.label),
    formula: FORMULA_RULES.map((rule) => rule.label)
  };

  const SKINCARE_BEAUTY = new Set([
    "face-care",
    "body-care",
    "hair-care",
    "makeup",
    "beauty-tools",
    "self-care-kits"
  ]);

  const emptyFacets = () => ({
    type: [],
    concern: [],
    formula: []
  });

  const buildHaystack = (product) =>
    ` ${[product.title, ...(product.tags || [])]
      .join(" ")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ")} `;

  const matchRules = (haystack, rules) =>
    rules.filter((rule) => rule.patterns.some((pattern) => pattern.test(haystack))).map((rule) => rule.label);

  const getProductFacets = (product) => {
    const categories = Array.isArray(product.categories) ? product.categories : [];

    if (!categories.some((handle) => SKINCARE_BEAUTY.has(handle))) {
      return emptyFacets();
    }

    const haystack = buildHaystack(product);

    return {
      type: matchRules(haystack, TYPE_RULES),
      concern: categories.includes("face-care") ? matchRules(haystack, CONCERN_RULES) : [],
      formula: matchRules(haystack, FORMULA_RULES)
    };
  };

  document.querySelectorAll("[data-collection-grid]").forEach((root) => {
    const productScript = root.querySelector("[data-collection-products]");
    const grid = root.querySelector("[data-product-grid]");
    const sidebar = root.querySelector("[data-filter-sidebar]");
    const filterGroups = root.querySelector("[data-filter-groups]");
    const activeFilters = root.querySelector("[data-active-filters]");
    const countNode = root.querySelector("[data-product-count]");
    const sortSelect = root.querySelector("[data-sort-select]");
    const filterOpen = root.querySelector("[data-filter-open]");
    const filterClose = root.querySelector("[data-filter-close]");
    const filterScrim = root.querySelector("[data-filter-scrim]");
    const emptyState = root.querySelector("[data-empty-state]");
    const clearEmpty = root.querySelector("[data-clear-empty]");
    const filterBadge = root.querySelector("[data-filter-badge]");

    if (!productScript || !grid) return;

    let rawProducts = [];

    try {
      rawProducts = JSON.parse(productScript.textContent || "[]");
    } catch (error) {
      return;
    }

    const cards = Array.from(root.querySelectorAll("[data-collection-product]"));
    if (!cards.length) return;

    const cardByHandle = new Map(cards.map((card) => [card.dataset.handle, card]));
    const products = rawProducts.map((product, index) => ({
      ...product,
      index,
      price: Number(product.price) || 0,
      vendor: product.vendor || "",
      title: product.title || "",
      tags: Array.isArray(product.tags) ? product.tags : [],
      categories: Array.isArray(product.categories) ? product.categories : [],
      brands: Array.isArray(product.brands) ? product.brands : [],
      facets: getProductFacets(product)
    }));

    const availableGroups = CATEGORY_GROUPS.map((group) => ({
      ...group,
      subcategories: group.subcategories.filter((subcategory) =>
        products.some((product) => product.categories.includes(subcategory.slug))
      )
    })).filter((group) => group.subcategories.length > 0);

    const totalAvailableCats = availableGroups.reduce(
      (count, group) => count + group.subcategories.length,
      0
    );

    const availableBrands = CANONICAL_BRANDS.filter((brand) =>
      products.some((product) => product.brands.includes(brand.slug))
    );

    const availableFacetGroups = FACET_DEFS.map((definition) => {
      const presentOptions = new Set();

      products.forEach((product) => {
        (product.facets[definition.id] || []).forEach((value) => presentOptions.add(value));
      });

      return {
        ...definition,
        options: FACET_OPTION_ORDER[definition.id].filter((option) => presentOptions.has(option))
      };
    }).filter((group) => group.options.length >= 2);

    const hasSidebar =
      totalAvailableCats > 1 ||
      availableBrands.length > 1 ||
      availableFacetGroups.length > 0;

    const state = {
      sort: "featured",
      activeCats: [],
      activeBrands: [],
      activeFacets: emptyFacets(),
      mobileOpen: false
    };

    const toggleValue = (values, target) =>
      values.includes(target)
        ? values.filter((value) => value !== target)
        : [...values, target];

    const getActiveCount = () =>
      state.activeCats.length +
      state.activeBrands.length +
      Object.keys(state.activeFacets).reduce(
        (count, key) => count + state.activeFacets[key].length,
        0
      );

    const hasActiveFilters = () => getActiveCount() > 0;

    const setMobileFiltersOpen = (isOpen) => {
      state.mobileOpen = Boolean(isOpen) && hasSidebar;
      root.classList.toggle("is-filter-open", state.mobileOpen);

      if (filterScrim) {
        filterScrim.hidden = !state.mobileOpen;
      }
    };

    const clearAllFilters = () => {
      state.activeCats = [];
      state.activeBrands = [];
      state.activeFacets = emptyFacets();
      applyFilters();
    };

    const filterOptionMarkup = (kind, value, label, checked, facetId) => `
      <li>
        <label class="collection-filter-option">
          <input
            type="checkbox"
            data-filter-kind="${escapeHtml(kind)}"
            ${facetId ? `data-facet-id="${escapeHtml(facetId)}"` : ""}
            value="${escapeHtml(value)}"
            ${checked ? "checked" : ""}
          >
          <span>${escapeHtml(label)}</span>
        </label>
      </li>
    `;

    const renderFilterPanel = () => {
      if (!filterGroups) return;

      const sections = [];

      if (totalAvailableCats > 1) {
        availableGroups.forEach((group) => {
          sections.push(`
            <section class="collection-filter-group">
              <h3 class="collection-filter-group__title">${escapeHtml(group.title)}</h3>
              <ul class="collection-filter-list">
                ${group.subcategories
                  .map((subcategory) =>
                    filterOptionMarkup(
                      "category",
                      subcategory.slug,
                      subcategory.title,
                      state.activeCats.includes(subcategory.slug)
                    )
                  )
                  .join("")}
              </ul>
            </section>
          `);
        });
      }

      availableFacetGroups.forEach((group) => {
        sections.push(`
          <section class="collection-filter-group">
            <h3 class="collection-filter-group__title">${escapeHtml(group.title)}</h3>
            <ul class="collection-filter-list">
              ${group.options
                .map((option) =>
                  filterOptionMarkup(
                    "facet",
                    option,
                    option,
                    state.activeFacets[group.id].includes(option),
                    group.id
                  )
                )
                .join("")}
            </ul>
          </section>
        `);
      });

      if (availableBrands.length > 1) {
        sections.push(`
          <section class="collection-filter-group">
            <h3 class="collection-filter-group__title">Brand</h3>
            <ul class="collection-filter-list">
              ${availableBrands
                .map((brand) =>
                  filterOptionMarkup(
                    "brand",
                    brand.slug,
                    brand.title,
                    state.activeBrands.includes(brand.slug)
                  )
                )
                .join("")}
            </ul>
          </section>
        `);
      }

      if (hasActiveFilters()) {
        sections.push(`
          <div class="collection-filter-actions">
            <button class="button button--ghost collection-filter-actions__clear" type="button" data-clear-all>
              Clear all filters
            </button>
          </div>
        `);
      }

      filterGroups.innerHTML = sections.join("");
    };

    const renderActiveFilters = () => {
      if (!activeFilters) return;

      const chips = [];

      state.activeCats.forEach((slug) => {
        chips.push(`
          <button class="tag tag--button" type="button" data-remove-kind="category" data-remove-value="${escapeHtml(slug)}">
            ${escapeHtml(CATEGORY_LABELS[slug] || slug)}
          </button>
        `);
      });

      state.activeBrands.forEach((brand) => {
        chips.push(`
          <button class="tag tag--button" type="button" data-remove-kind="brand" data-remove-value="${escapeHtml(brand)}">
            ${escapeHtml(BRAND_LABELS[brand] || brand)}
          </button>
        `);
      });

      Object.keys(state.activeFacets).forEach((facetId) => {
        state.activeFacets[facetId].forEach((value) => {
          chips.push(`
            <button
              class="tag tag--button"
              type="button"
              data-remove-kind="facet"
              data-remove-facet-id="${escapeHtml(facetId)}"
              data-remove-value="${escapeHtml(value)}"
            >
              ${escapeHtml(value)}
            </button>
          `);
        });
      });

      if (chips.length) {
        chips.push(`
          <button class="tag tag--button tag--clear" type="button" data-clear-all>
            Clear all
          </button>
        `);
      }

      activeFilters.innerHTML = chips.join("");
      activeFilters.hidden = chips.length === 0;
    };

    const applyFilters = () => {
      let filtered = products.filter((product) => {
        if (
          state.activeCats.length &&
          !product.categories.some((category) => state.activeCats.includes(category))
        ) {
          return false;
        }

        if (
          state.activeBrands.length &&
          !product.brands.some((brand) => state.activeBrands.includes(brand))
        ) {
          return false;
        }

        return Object.keys(state.activeFacets).every((facetId) => {
          const selected = state.activeFacets[facetId];
          if (!selected.length) return true;

          const values = product.facets[facetId] || [];
          return values.some((value) => selected.includes(value));
        });
      });

      filtered = [...filtered];

      switch (state.sort) {
        case "price-asc":
          filtered.sort((left, right) => left.price - right.price || left.index - right.index);
          break;
        case "price-desc":
          filtered.sort((left, right) => right.price - left.price || left.index - right.index);
          break;
        case "name-asc":
          filtered.sort((left, right) => left.title.localeCompare(right.title));
          break;
        default:
          filtered.sort(
            (left, right) =>
              Number(right.featured) - Number(left.featured) || left.index - right.index
          );
      }

      const fragment = document.createDocumentFragment();
      const visibleHandles = new Set(filtered.map((product) => product.handle));

      cards.forEach((card) => {
        card.hidden = !visibleHandles.has(card.dataset.handle);
      });

      filtered.forEach((product) => {
        const card = cardByHandle.get(product.handle);
        if (card) {
          fragment.appendChild(card);
        }
      });

      grid.appendChild(fragment);

      if (countNode) {
        countNode.textContent = `${filtered.length} ${filtered.length === 1 ? "product" : "products"}`;
      }

      if (emptyState) {
        emptyState.hidden = filtered.length !== 0;
      }

      if (sidebar) {
        sidebar.hidden = !hasSidebar;
      }

      if (filterOpen) {
        filterOpen.hidden = !hasSidebar;
      }

      if (filterBadge) {
        const activeCount = getActiveCount();
        filterBadge.hidden = activeCount === 0;
        filterBadge.textContent = String(activeCount);
      }

      if (!hasSidebar) {
        setMobileFiltersOpen(false);
      }

      renderFilterPanel();
      renderActiveFilters();
    };

    if (filterGroups) {
      filterGroups.addEventListener("change", (event) => {
        const input = event.target.closest("input[data-filter-kind]");
        if (!input) return;

        if (input.dataset.filterKind === "category") {
          state.activeCats = toggleValue(state.activeCats, input.value);
        } else if (input.dataset.filterKind === "brand") {
          state.activeBrands = toggleValue(state.activeBrands, input.value);
        } else if (input.dataset.filterKind === "facet" && input.dataset.facetId) {
          const facetId = input.dataset.facetId;
          state.activeFacets = {
            ...state.activeFacets,
            [facetId]: toggleValue(state.activeFacets[facetId], input.value)
          };
        }

        applyFilters();
      });

      filterGroups.addEventListener("click", (event) => {
        const clearButton = event.target.closest("[data-clear-all]");
        if (!clearButton) return;
        clearAllFilters();
      });
    }

    if (activeFilters) {
      activeFilters.addEventListener("click", (event) => {
        const button = event.target.closest("button");
        if (!button) return;

        if (button.hasAttribute("data-clear-all")) {
          clearAllFilters();
          return;
        }

        const value = button.dataset.removeValue;
        if (!value) return;

        if (button.dataset.removeKind === "category") {
          state.activeCats = state.activeCats.filter((item) => item !== value);
        } else if (button.dataset.removeKind === "brand") {
          state.activeBrands = state.activeBrands.filter((item) => item !== value);
        } else if (
          button.dataset.removeKind === "facet" &&
          button.dataset.removeFacetId
        ) {
          const facetId = button.dataset.removeFacetId;
          state.activeFacets = {
            ...state.activeFacets,
            [facetId]: state.activeFacets[facetId].filter((item) => item !== value)
          };
        }

        applyFilters();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener("change", (event) => {
        state.sort = event.target.value || "featured";
        applyFilters();
      });
    }

    if (filterOpen) {
      filterOpen.addEventListener("click", () => setMobileFiltersOpen(true));
    }

    if (filterClose) {
      filterClose.addEventListener("click", () => setMobileFiltersOpen(false));
    }

    if (filterScrim) {
      filterScrim.addEventListener("click", () => setMobileFiltersOpen(false));
    }

    if (clearEmpty) {
      clearEmpty.addEventListener("click", clearAllFilters);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 990) {
        setMobileFiltersOpen(false);
      }
    });

    applyFilters();
  });
});
